// theirs
import styled from 'styled-components'
// ours
import { TakeActionProps } from '.'
import { respondToRetina, respondToWidth } from '../../../mixins/respondTo'
import { breakpoints, color, typography } from '../../../styles'

export const takeActionBaseClass = 'take-action'

export const StyledTakeAction = styled.div<TakeActionProps>`
    &.${takeActionBaseClass} {
        background: linear-gradient(180deg, #5d4997, #b8699b);
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;
        display: table;
        z-index: 2;

        .content-outer {
            display: table-cell;
            vertical-align: middle;
            padding-top: 5%;
        }

        .content-inner {
            margin: 0 auto;
        }

        .title-wrapper {
            display: block;
            margin: 0 0 1.5rem 0;
        }

        h2 {
            font-family: ${typography.type.secondary};
            font-weight: ${typography.weight.bold};
            font-style: ${typography.style.normal};

            color: ${color.lumber};
            text-transform: uppercase;
            text-align: center;
            margin: 0;
            padding: 0;

            letter-spacing: normal;
            line-height: normal;

            font-size: ${typography.size.l5};
            ${respondToWidth.xs`
            font-size: ${typography.size.code};
        `}

            ${respondToWidth.xl`
            font-size: ${typography.size.code2};
        `}

        ${respondToRetina.xxxxl`
            font-size: ${typography.size.code3};
        `}
        }

        .text-wrapper {
            display: block;
            padding: 0;
            align-self: center;
            margin: 0 auto 3rem auto;
            max-width: 300px;

            @media (min-width: ${breakpoints.xs}) {
                max-width: 350px;
            }

            @media (min-width: ${breakpoints.sm}) {
                max-width: 550px;
            }

            @media (min-width: ${breakpoints.lg}) {
                max-width: 760px;
                padding: 0;
            }

            p {
                text-align: ${(props) =>
                    props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.1;
                letter-spacing: 2px;
                text-align: center;
                color: ${color.lightest};

                font-size: ${typography.size.m2};
                @media (min-width: ${breakpoints.xs}) {
                    font-size: ${typography.size.m3};
                }

                @media (min-width: ${breakpoints.lg}) {
                    font-size: ${typography.size.l1};
                }
            }
        }

        .call-to-action-wrapper {
            text-align: center;

            a {
                font-family: ${typography.type.secondary};
                font-weight: ${typography.weight.bold};
                font-style: ${typography.style.normal};
                font-size: ${typography.size.m1};
                text-transform: uppercase;
                text-decoration: none;
                color: ${color.lightest};
                border-color: ${color.lightest};
                border-style: solid;
                border-width: 3px;
                border-radius: 30px;
                padding: 10px 32px 6px 32px;
                width: 200px;
                display: block;
                margin: 0 auto;
                line-height: 1;
            }
        }
    }
`
